import { clsx } from 'clsx';
import { useState } from 'react';
import { HiXMark } from 'react-icons/hi2';

interface HolidayBarProps {
  className?: string;
}

const TURNAROUND_URL = 'https://bordr.com/turnaround';
const START_DATE = new Date('2026-06-15');
const EXPIRY_DATE = new Date('2026-09-15');
const COOKIE_NAME = 'holiday_banner_dismissed';

const shouldShowBanner = (): boolean => {
  const now = new Date();
  // Only show within the campaign window (June 15 – Sep 15, 2026)
  if (now < START_DATE || now >= EXPIRY_DATE) {
    return false;
  }

  // Check for existing cookie
  const cookies = document.cookie.split(';');
  const dismissedCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${COOKIE_NAME}=`),
  );

  return !dismissedCookie;
};

export function HolidayBar({ className }: HolidayBarProps): JSX.Element | null {
  const [isVisible, setIsVisible] = useState(shouldShowBanner);

  const handleDismiss = (): void => {
    // Set cookie that expires on EXPIRY_DATE
    const cookie = `${COOKIE_NAME}=true; expires=${EXPIRY_DATE.toUTCString()}; path=/`;
    document.cookie = cookie;
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={clsx(
        'flex items-center gap-x-6 bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1',
        className,
      )}
    >
      <p className="text-sm/6 text-white">
        ☀️ See our current&nbsp;
        <a
          href={TURNAROUND_URL}
          className="font-semibold text-white"
          target="_blank"
          rel="noreferrer"
        >
          turnaround times →
        </a>
        &nbsp;due to summer holidays in Portugal. ☀️
      </p>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
          onClick={handleDismiss}
        >
          <span className="sr-only">Dismiss</span>
          <HiXMark aria-hidden="true" className="size-5 text-white" />
        </button>
      </div>
    </div>
  );
}

export default HolidayBar;
